export default function () {
    let $sections = $('.js-infinite-scroll');

    if ($sections.length > 0) {
        $sections.each(function (index, el) {
            handleScrollingSection($(el));
        });
    }
}

export function handleScrollingSection($section, minWidth = 1200, maxWidth = null) {
    if ($section.length !== 1) {
        return;
    }

    let offset = 0;
    let dragging = false;
    let lastX = -1;
    let velocity = 0;
    let totalWidth = 0;
    let enabled = false;
    let lastFrame = (new Date).getTime();

    let $wrap = $section.find(".js-scrolling-wrap");
    let $groups = $section.find(".js-scrolling-item");

    let mouseMove = function (e) {
        let diff = lastX - e.pageX;
        lastX = e.pageX;

        setTestimonialOffset(offset + diff);
        velocity = diff;
    };

    let mouseUp = function (e) {
        $(window).off("mousemove", mouseMove).off("mouseup", mouseUp);
        dragging = false;
        lastFrame = (new Date).getTime();
    };
    let touchMove = function (e) {
        let diff = lastX - e.originalEvent.touches[0].pageX;
        lastX = e.originalEvent.touches[0].pageX;

        setTestimonialOffset(offset + diff);
        velocity = diff;
    };

    let touchEnd = function (e) {
        $(window).off("touchmove", touchMove).off("touchcancel touchend", touchEnd);
        dragging = false;
    };


    $groups.on("mousedown", function (e) {
        if (!enabled) {
            return true;
        }
        if (dragging) {
            return false;
        }
        dragging = true;

        lastX = e.pageX;
        $(window).on("mousemove", mouseMove).on("mouseup", mouseUp);

        return false;
    }).on("touchstart", function (e) {
        if (!enabled || e.originalEvent.cancelable === false) {
            return true;
        }
        if (dragging) {
            return false;
        }
        dragging = true;

        lastX = e.originalEvent.touches[0].pageX;
        $(window).on("touchmove", touchMove).on("touchcancel touchend", touchEnd);

        return false;
    });
    $(window).on("resize", function () {
        if ($(window).outerWidth() >= minWidth && (maxWidth === null || $(window).outerWidth() <= maxWidth)) {
            if (enabled) {
                updateTotalWidth();
                setTestimonialOffset(offset);
            } else {
                offset = 0;
                enable();
            }
        } else {
            disable();
        }
    });

    if ($(window).outerWidth() >= minWidth && (maxWidth === null || $(window).outerWidth() <= maxWidth)) {
        enable();
    }

    function enable() {
        if (enabled) {
            return;
        }

        enabled = true;
        updateTotalWidth();
        $groups.css("position", "absolute");
        updateLayout();
        requestAnimationFrame(updateTestimonialSlider);
    }

    function disable() {
        if (!enabled) {
            return;
        }

        enabled = false;
        $groups.css("position", "").css("left", "").css("transform", "");
        $wrap.css("transform", "");

        dragging = false;
        $(window).off("touchmove", touchMove).off("touchcancel touchend", touchEnd).off("mousemove", mouseMove).off("mouseup", mouseUp);
    }

    function updateTotalWidth() {
        totalWidth = 0;
        $groups.each(function (_, group) {
            totalWidth += $(group).outerWidth();
        });
    }

    function updateTestimonialSlider() {
        if (!enabled) {
            return;
        }
        if (!dragging) {
            let now = (new Date).getTime();
            let dt = now - lastFrame;
            lastFrame = now;

            setTestimonialOffset(offset + (dt / 18.333) + velocity);
            velocity *= 0.85;
        }
        requestAnimationFrame(updateTestimonialSlider);
    }

    function setTestimonialOffset(_offset) {
        offset = _offset;

        offset = offset % totalWidth;
        if (offset < 0) {
            offset += totalWidth;
        }

        $wrap.css("transform", "translate3d(" + -offset + "px, 0, 0)");

        updateLayout();
    }

    function updateLayout() {
        let offSideOffset = 0;
        let seenOffset = 0;

        $groups.each(function (index, group) {
            let $group = $(group);

            let groupWidth = $group.outerWidth();

            if (seenOffset + groupWidth - offset < 0) {
                $group.css("transform", "translateX(" + (totalWidth + offSideOffset) + "px)");

                offSideOffset += groupWidth;
            } else {
                $group.css("transform", "translateX(" + seenOffset + "px)");
            }
            seenOffset += groupWidth;
        });
    }

}